<template>
	<div class="chat-item-panel" :class="[{'left':source[senderType] == 1},{'right':source[senderType] == 2}]">
		<span class="sign" v-if="source[senderType] != 3">
			<time>{{transformTime(source)}}</time>
			<span style="margin-left: 5px;">{{getNickname(source)}}</span>
		</span>
		<span class="desc" v-if="source[senderType] != 3">
			<text-message :content="source.msg" v-if="source.type == 'text' || source.msgType == 'text'" :bgClass="source[senderType] == 1 ? 'left':'right'"></text-message>
			<image-message :src="$$(source.attachment,'url')" v-if="source.type == 'image'" :bgClass="source[senderType] == 1 ? 'left':'right'"></image-message>
			<file-message  :file="source.attachment" v-if="source.type == 'file'"></file-message>
			<video-message :src="$$(source.attachment,'fileurl')" v-if="source.type == 'video'"></video-message>
			<voice-message :src="$$(source.attachment,'url')" v-if="source.type == 'voice'"></voice-message>
			<card-message :data="source" v-if="source.type == 'news'"></card-message>
			<link-message :data="source"  :bgClass="source[senderType] == 1 ? 'left':'right'" v-if="source.type == 'link'"></link-message>
			<mini-program-message :data="source.miniProgram" v-if="source.type == 'miniprogrampage'" keys='thumb_media_id'></mini-program-message>
			<el-tooltip class="item" effect="dark" :content="source.sendErrMsg" >
			     <span class="error-tips" v-show="source.sendStatus == false" @click="reSendMessage(source)">
			         <i class="iconfont major-warning" style="margin-right:3px"></i>
			     </span>
			  </el-tooltip>
			<span class="loadding" v-loading="source.loading" element-loading-spinner="el-icon-loading"></span>
		</span>
		<!-- <p v-if="source[senderType] == 3 && source.msg" v-html="(source.sys_sign == '4.1' || source.sender_id == '4.1') ?'满意度评价' : source.msg"></p> -->
		<system-message v-if="source[senderType] == 3 && source.msg" :content="source.msg"></system-message>
	</div>
</template>
<script>
	import { friendlyFormatTime } from '@/utils/imService';
	export default {
		props: {
			senderType:{
				default:'sender_type'
			},
			source: {
			  type: Object,
			  default () {
				return {}
			  }
			}
		},
		methods:{
			getNickname(data){
				if(data.nickname) return `【${data.nickname}】`;
				if(data[this.senderType] == 2){
					return `【${this.$store.state.user.name}】`;
				}else {
					return this.$store.state.imChatService.index_infos?.nickname ? `【${this.$store.state.imChatService.index_infos?.nickname }】` : '';
				}
			},
			transformTime(data){
				if(typeof data.sendtime == 'number') return friendlyFormatTime(this.$dayjs(data.sendtime).format('YYYY-MM-DD HH:mm:ss'));
				return friendlyFormatTime(data.sendtime);
			},
			reSendMessage(data) {
				data.loading = true;
				data.sendStatus = true;
				this.$api.toSendImServiceDialogue(data).then(res => {
					if(res.errcode == 0) {
						this.$nextTick(()=>{
							data.loading = false;
							data.sendStatus = true
							this.$nextTick(()=>{
								this.$forceUpdate();
								// console.log(data)
							})
							let elChatPanel = document.getElementById('majorelChatPanel');
							elChatPanel.scrollTop = elChatPanel.scrollHeight
						})
					}else {
						data.loading = false
						data.sendStatus = false
						this.$forceUpdate()
					}
				}).catch(err => {
					data.loading = false;
					data.sendStatus = false
					this.$forceUpdate()
				})
			}
		}
	};
</script>
<style lang="scss">
	.chat-item-panel {
		display: flex;
		flex-direction: column;
		color: #838a9d;
		font-size: 12px;
		margin: 15px 0;

		&:nth-of-type(n + 2) {
			margin-top: 10px;
		}

		.sign {
			display: block;
			margin-bottom: 5px;
		}
		.desc {
			display: flex;
			.error-tips {
			  display: inline-block;
			  height: 30px;
			  line-height: 30px;
			  padding: 0 8px;
			  background: #ffe3e3;
			  border-radius: 4px;
			  margin-left: 10px;
			  color: #ff504d;
			  font-size: 12px;
			  position: relative;
			  cursor: pointer;
			  &::before {
			    display: inline-block;
			    position: absolute;
			    content: "";
			    width: 0;
			    height: 0;
				top: 10px;
			  }
			}
			.loadding {
			  height: 30px;
			  line-height: 30px;
			  display: inline-block;
			  position: relative;
			  top: 5px;
			  margin-left: 10px;
			  .el-loading-spinner {
			   
			    .major-loading {
			      color: #2e2e2e;
			    }
			  }
			}
		}

		&.left {
			.desc {
				.error-tips {
					&::before {
						border-top: 5px solid transparent;
						border-right: 5px solid #ffe3e3;
						border-bottom: 5px solid transparent;
						border-left: 5px solid transparent;
						left: -9px;
					}
				}
			}
		}

		&.right {
			align-items: flex-end;

			.desc {
				flex-direction: row-reverse;

				.chat-type-text {
					background-color: #edf5ff;
				}

				.error-tips {
					margin-left: 0;
					margin-right: 8px;

					&::before {
						border-top: 5px solid transparent;
						border-right: 5px solid transparent;
						border-bottom: 5px solid transparent;
						border-left: 5px solid #ffe3e3;
						right: -9px;
					}
				}

				.loadding {
					left: -30px;
				}
			}
		}
	}
</style>
